export default function Hero() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://images.unsplash.com/photo-1609704001758-682c89a4d8b3?crop=entropy&cs=tinysrgb&fit=max&ixid=M3w3Mzk3NjZ8MHwxfHNlYXJjaHwzfHxUZXhhc3xlbnwwfHx8fDE3NzU0MjU5MDR8MA&ixlib=rb-4.1.0&w=1080&auto=format"
        alt="Texas flag"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-texas-navy/60 via-texas-navy/40 to-texas-navy/60" />

      {/* "Texas-Based. Nationally Trusted." — positioned midway between top and center */}
      <div className="absolute top-[22%] w-full text-center z-10 px-6">
        <span className="text-white font-bold text-lg md:text-xl tracking-widest uppercase drop-shadow-lg">
          Texas-Based. Nationally Trusted.
        </span>
      </div>

      <div className="relative z-10 w-full text-center px-6">
        <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-4 drop-shadow-lg">
          Texas Consultancy<br className="hidden md:block" /> and Sales Agency
        </h1>
        <p className="text-lg md:text-xl text-white/85 mb-8 drop-shadow max-w-2xl mx-auto">
          Transform Your Business. Maximize Profitability. Achieve Strategic Growth.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#products"
            className="inline-block bg-texas-red hover:bg-texas-red-dark text-white text-sm font-semibold px-8 py-3 rounded-md transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            Explore Our Services
          </a>
          <a
            href="#contact"
            className="inline-block bg-white/15 hover:bg-white/25 border border-white/40 text-white text-sm font-semibold px-8 py-3 rounded-md transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            Schedule a Consultation
          </a>
        </div>
      </div>
    </section>
  );
}
